import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  provideHttpClient,
  withInterceptorsFromDi,
  HttpClientModule,
} from '@angular/common/http';
import { AgGridModule } from 'ag-grid-angular';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
// Angular Material Modules
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { TableComponent } from './components/table/table.component';
import { CustomActionCellRendererComponent } from './components/table/custom-action-cell-renderer/custom-action-cell-renderer.component';
import { ResourceNameCellRendererComponent } from './components/table/resource-name-cell-renderer/resource-name-cell-renderer.component';
import { CopyCellRendererComponent } from './components/table/copy-cell-renderer/copy-cell-renderer.component';
import { AttachmentRenderer } from './components/table/attachment-renderer/attachment-renderer.component';
import { StatusLabelComponent } from './components/Status-Label/status-label.component';
import { ButtonGroupComponent } from './components/button-group/button-group.component';
import { TitleFieldComponent } from './components/title-field/title-field.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldInputModule } from '@emerald-angular/input';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { ViewFileComponent } from './components/view-file/view-file.component';
import { PerformanceFilterComponent } from './modals/performance-filter/performance-filter.component';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { EmployeeDetailsComponent } from './components/employee-details/employee-details.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
// Reusable popups
// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

@NgModule({
  declarations: [
    TableComponent,
    CustomActionCellRendererComponent,
    ResourceNameCellRendererComponent,
    CopyCellRendererComponent,
    ButtonGroupComponent,
    BreadcrumbComponent,
    TitleFieldComponent,
    InputFieldComponent,
    AttachmentRenderer,
    ViewFileComponent,
    PerformanceFilterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AgGridModule,
    StatusLabelComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    EmeraldButtonModule,
    EmeraldInputModule,
    EmeraldIconModule,
    EmeraldDropdownModule,
    ConfirmationDialogComponent,
    EmployeeDetailsComponent,
    DropdownComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableComponent,
    ButtonGroupComponent,
    BreadcrumbComponent,
    TitleFieldComponent,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    InputFieldComponent,
    PerformanceFilterComponent,
    ConfirmationDialogComponent,
    EmployeeDetailsComponent,
    DropdownComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}